"use strict";

angular.module("internal.exams").controller("InternalExamSessionDocuments", [
    "$scope",
    "$stateParams",
    "EXSessions",
    "EXCandidates",
    function ($scope, $stateParams, EXSessions, EXCandidates) {
        $scope.loading = true;
        $scope.candidates = []
        $scope.examSessionID = $stateParams.examSessionID;

        EXSessions.getdocuments($stateParams.examSessionID).then(function (documents) {
            $scope.documents = documents.records;
            $scope.documents.forEach(function (document) {
                document.examSessionID = $stateParams.examSessionID;
            });
        });

        EXSessions.getsessionsummary($stateParams.examSessionID).then(function (sessionSummary) {
            $scope.sessionSummary = sessionSummary;
        });

        EXCandidates.getCandidateBySession($scope.examSessionID).then(function (candidates) {
            candidates.records.forEach(function (candidate) {
                $scope.candidates.push({ name: candidate.candidateUserDisplayName, id: candidate.candidateUserId })
            })
            $scope.loading = false;
        })

        $scope.columns = [
            {
                label: "Name",
                field: "name",
                link: {
                    state: "internal.exams.session.document",
                    params: [
                        {
                            name: "documentID",
                            field: "id"
                        },
                        {
                            name: "examSessionID",
                            field: "examSessionID"
                        },
                        {
                            name: "candidateID",
                            field: "candidateId"
                        }
                    ]
                }
            },
            {
                label: "Candidate",
                field: "candidateName"
            },
            {
                label: "File",
                field: "fileName"
            },
            {
                label: "Size",
                field: "fileSize",
                type: 'file_size'
            },
            {
                label: "Created On",
                field: "createdOn",
                type: "date"
            },
            {
                label: "Created By",
                field: "createdByName"
            }
        ];
        $scope.filters = [
            {
                name: "Candidate",
                field: "candidateId",
                options: $scope.candidates
            }
        ];
    }
]);
